export default __webpack_public_path__ + "static/media/sport-fraud-fighter.4b4e6720.svg";